let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6lPSZ")).then(() => parcelRequire('7hDnX'));